export const VisualizationType = {
  LINE: "Line",
  BAR: "Bar",
  PIE: "Pie",
  TABLE: "Table"
};
